import { render, staticRenderFns } from "./Materiels.vue?vue&type=template&id=37c5c07b&"
import script from "./Materiels.vue?vue&type=script&lang=js&"
export * from "./Materiels.vue?vue&type=script&lang=js&"
import style0 from "./Materiels.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports